const eventCarrousel = {

  corro_ninos_2026: {

    titulo: "¿A QUIÉN BENEFICIA MI INSCRIPCIÓN?",

    images: [
      "https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/CORRO%20POR%20LOS%20NINOS%202026/PEERO2.jpg",
      "https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/CORRO%20POR%20LOS%20NINOS%202026/perro6.jpg",
      "https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/CORRO%20POR%20LOS%20NINOS%202026/perro4.jpg",
      "https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/CORRO%20POR%20LOS%20NINOS%202026/perro5.jpg",
      "https://ik.imagekit.io/twn1y7ldf/Nuevo_ATACA/CORRO%20POR%20LOS%20NINOS%202026/perro3.jpg"
    ],

    proximamente: false

  },

  chiguata_2026: {

    titulo: "GALERÍA DEL EVENTO",

    images: [
      "https://ejemplo.com/imagen-1.jpg",
      "https://ejemplo.com/imagen-2.jpg",
      "https://ejemplo.com/imagen-3.jpg"
    ],

    proximamente: false

  }

};

export default eventCarrousel;